"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _fieldsMessages = require("./fieldsMessages");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var InputFormInstruction = function InputFormInstruction() {
  var _useIntl = (0, _reactIntl.useIntl)(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "payment-widget__checkout_fields-instruction"
  }, "(", formatMessage(_fieldsMessages.inputFormInstruction.instruction), ")");
};
var _default = InputFormInstruction;
exports.default = _default;